// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background: forestgreen;
    color: #fff;
}

header img {
    height: 40px;
    cursor: pointer;
}

header button {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
}

header .dropdown {
    position: absolute;
    right: 0;
    top: 40px;
    background: #fff;
    color: forestgreen;
    border-radius: 5px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    width: 150px;
    z-index: 1000;
}

header .dropdown ul {
    list-style: none;
    margin: 0;
    padding: 10px 0;
}

header .dropdown ul li {
    padding: 10px 20px;
    cursor: pointer;
}

header .dropdown ul li a {
    text-decoration: none;
    color: #111525;
}

.navless-header{
    background-color: #368727;
    position: relative;
    color: white;
}

.navless-header h4 {
    margin-bottom: -5px;
}

.navless-header p {
    margin-top: 0;
    margin-bottom: 0;
}

.underline-link {
    color: white;
    text-decoration: underline;
}
.underline-link:hover {
    color: white;
    text-decoration: underline;
}


.page-container {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    position: relative;
}

.content {
    width: 100%;
    height: 100%;
    position: relative;
}

.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.loader {
    display: flex;
    justify-content: center;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 20px;\n    background: forestgreen;\n    color: #fff;\n}\n\nheader img {\n    height: 40px;\n    cursor: pointer;\n}\n\nheader button {\n    background: transparent;\n    border: none;\n    color: #fff;\n    font-size: 16px;\n    cursor: pointer;\n}\n\nheader .dropdown {\n    position: absolute;\n    right: 0;\n    top: 40px;\n    background: #fff;\n    color: forestgreen;\n    border-radius: 5px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    width: 150px;\n    z-index: 1000;\n}\n\nheader .dropdown ul {\n    list-style: none;\n    margin: 0;\n    padding: 10px 0;\n}\n\nheader .dropdown ul li {\n    padding: 10px 20px;\n    cursor: pointer;\n}\n\nheader .dropdown ul li a {\n    text-decoration: none;\n    color: #111525;\n}\n\n.navless-header{\n    background-color: #368727;\n    position: relative;\n    color: white;\n}\n\n.navless-header h4 {\n    margin-bottom: -5px;\n}\n\n.navless-header p {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.underline-link {\n    color: white;\n    text-decoration: underline;\n}\n.underline-link:hover {\n    color: white;\n    text-decoration: underline;\n}\n\n\n.page-container {\n    width: 100%;\n    height: 100vh;\n    margin: 0 auto;\n    position: relative;\n}\n\n.content {\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n\n.loader-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
